module.exports = __webpack_public_path__ + "img/dl4.34030c70.png";